module.exports = __webpack_public_path__ + "img/avatar-s-11.904e2a04.png";